import { find, findIndex, clone, propEq, isNil } from 'ramda';
const RADIO_WORM_LENGTH = 10;
const RIGHT_RADIO_QUESTIONS_LENGTH = 5;
const TEXTAREA_TYPE = 'textarea';
const RADIO_TYPE = 'radio';
const CHECKBOX_TYPE = 'checkbox';
/**
 * Находит разницу Айдишников полей ответов, между важными полями
 * @param setA - текущие ids
 * @param setB - обязательные Ids
 * @param keyB - ключ для id
 * @returns [nubmers]
 */
export const getDifference = ({
  arrA,
  arrB
}) => arrA.filter(value => !arrB.includes(value));
export const getQuestionsIds = answers => answers.map(({
  questionId
}) => questionId);
/**
 * Распределяет вопросы по четырем областям в зависимости от их типа
 * @param questions - вопросы
 * @returns {{top: Array, left: Array, bottom: Array, right: Array}}
 */
export const getQuestionPositions = questions => {
  const top = [];
  const left = [];
  const bottom = [];
  const right = [];
  questions.forEach(question => {
    const {
      type,
      answers = []
    } = question;
    switch (type) {
      case TEXTAREA_TYPE:
        left.push(question);
        break;
      case RADIO_TYPE:
        {
          if (answers.length === RIGHT_RADIO_QUESTIONS_LENGTH) {
            right.push(question);
          } else if (answers.length === RADIO_WORM_LENGTH) {
            top.push(question);
          }
          break;
        }
      case CHECKBOX_TYPE:
        bottom.push(question);
        break;
      default:
        break;
    }
  });
  return {
    top,
    left,
    bottom,
    right
  };
};
/**
 * Трансформация ответов
 * @param answers - старые ответы
 * @param question - объект вопроса
 * @param answer - объект ответа
 * @param segmentId - сегмент по которому формируется ответ
 */
export const changeNewAnswers = (answers, {
  question,
  answer
}) => {
  const {
    segmentId
  } = question;
  const newAnswer = {
    questionId: question.id,
    answerId: answer.id,
    value: answer.value,
    type: question.type
  };
  let newAnswers = clone(answers);
  let oldSegmentAnswerIndex;
  if (segmentId) {
    newAnswer.segmentId = segmentId;
    if (question.type !== CHECKBOX_TYPE) {
      oldSegmentAnswerIndex = findIndex(oldAnswer => oldAnswer.segmentId === segmentId && oldAnswer.questionId === question.id)(answers);
    } else {
      oldSegmentAnswerIndex = findIndex(oldAnswer => oldAnswer.segmentId === segmentId && oldAnswer.questionId === question.id && oldAnswer.answerId === answer.id)(answers);
    }
    if (oldSegmentAnswerIndex + 1) {
      newAnswers[oldSegmentAnswerIndex] = newAnswer;
    } else {
      newAnswers = newAnswers.concat(newAnswer);
    }
  } else {
    const oldAnswerIndex = findIndex(oldAnswer => oldAnswer.questionId === question.id)(answers);
    if (oldAnswerIndex + 1) {
      newAnswers[oldAnswerIndex] = newAnswer;
    } else {
      newAnswers = newAnswers.concat(newAnswer);
    }
  }
  return newAnswers;
};
/**
 * Функция заплатка для получения вариантов ответов,
 * свойственных именно этому сегменту
 * @param questions - общие вопросы
 * @param segment - сегмент
 * @returns {*} - вопросы адаптированные под сегмент в сегменте
 */
export const getGroupSegmentQuestions = (questions, segment) => {
  if (!segment) {
    return questions;
  }
  let newQuestions = clone(questions);
  const options = isNil(segment.options) ? [] : segment.options;
  const questionCheckboxIndex = findIndex(propEq('type', CHECKBOX_TYPE), newQuestions);
  const questionCheckboxAnswers = questions[questionCheckboxIndex].answers;
  newQuestions[questionCheckboxIndex].answers = [];
  options.forEach(option => {
    const ansOption = find(propEq('name', option), questionCheckboxAnswers);
    if (ansOption) {
      newQuestions[questionCheckboxIndex].answers.push({
        ...ansOption,
        value: true
      });
    }
  });
  newQuestions = newQuestions.map(newQuestion => ({
    ...newQuestion,
    segmentId: segment.segmentId
  }));
  return newQuestions;
};
/**
 * Функция отмечает все имеющиеся чекбоксы
 */
export const getDefaultAnswers = groups => {
  const answers = [];
  groups.forEach(group => {
    group.questions.forEach(question => {
      if (question.type === CHECKBOX_TYPE) {
        question.answers.forEach(answer => {
          answers.push({
            answerId: answer.id,
            questionId: question.id,
            segmentId: question.segmentId,
            type: question.type,
            value: answer.value
          });
        });
      }
    });
  });
  return answers;
};